export const capitalizeFirstLetterInEachWord = (str: string): string => {
    return str
        .replace(/_/g, ' ')
        .replace(/\s+(.)/g, (m, chr) => ' ' + chr.toUpperCase())
        .replace(/^\w/, (chr) => chr.toUpperCase())
}

export const capitalizeFirstLetterOfWord = (
    str: string | undefined | null,
): string => {
    if (!str) {
        return 'N/A'
    }
    const stringiFiedWord = str.toString()
    return stringiFiedWord.charAt(0).toUpperCase() + stringiFiedWord.slice(1)
}

export const convertNumberToString = (number: number | null): string => {
    if (number === null) {
        return 'N/A'
    }
    return number.toString()
}

/**
 * This method converts a string to camel case
 * @param input
 * @returns
 */
export const toCamelCase = (input: string): string => {
    return input
        .split(/[\s_-]+/) // Split the string by spaces, hyphens, or underscores
        .map(
            (word, index) =>
                index === 0
                    ? word.toLowerCase() // Keep the first word lowercase
                    : word.charAt(0).toUpperCase() +
                      word.slice(1).toLowerCase(), // Capitalize the first letter of subsequent words
        )
        .join('') // Join the words without spaces
}

export function toReadableLabel(key: string): string {
    // insert space before capital letters
    const withSpaces = key.replace(/([A-Z])/g, ' $1')
    // capitalize first letter
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1)
}

/**
 *
 * @param str
 * @returns
 * This method checks if a string is alphaNumber or not
 */
export const isAlphaNumeric = (str: string): boolean => {
    return /^[a-zA-Z0-9]+$/.test(str)
}

export const isEmptyObject = (obj: object): boolean => {
    for (const k in obj) {
        if (Object.hasOwn(obj, k)) {
            return false // found one key, not empty
        }
    }
    return true // no own keys
}

export const isStringifiedNull = (str: string): boolean => {
    return str === 'null'
}

export const returnNullIfStringifiedNull = <T>(str: T): T | null => {
    return (str as unknown) === 'null' ? null : str
}

export const getPrimitiveDisplayValue = (value: unknown): string => {
    switch (typeof value) {
        case 'string':
            return value
        case 'number':
        case 'boolean':
        case 'bigint':
            return `${value}`
        default:
            return ''
    }
}
